import { useAuth } from '@workos-inc/authkit-react';
import { canSeeRestricted } from '~portal/lib';

/**
 * @desc Whether the signed-in user is shown the Restricted section — the nav group and the
 * `/restricted/*` pages. Reads the token claims AuthKit already holds rather than `users.me`, so
 * the answer is there on first render inside the protected layout (which renders only once auth
 * has settled) and never flickers in after a profile round trip. See `canSeeRestricted`.
 */
export function useRestrictedAccess(): boolean {
  const { roles, permissions } = useAuth();
  return canSeeRestricted({ roles, permissions });
}
